import { Box, Button, Grid, Paper } from '@material-ui/core';
import { DataGrid, GridColumns, GridRowData } from '@mui/x-data-grid';
import React, { useState, useEffect } from 'react';
import { getAllAffirmations } from '../../../api/api';
import { AffirmationWithCategory } from '../../../interfaces/tell_me/affirmationWithCategory.types';
import QuickSearchToolbar from './QuickSearchToolbar';
import DeleteAffirmationDialog from './Delete_Dialog';
import UpdateAffirmationDialog from './Update_Dialog';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store/store';
import { getCategoryNamesByIds } from '../../../utility/getCategoryNames';

function escapeRegExp(value: string): string {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

function AllAffirmationsComponent() {

    // Table Header
    const columns: GridColumns = [
        {
            field: "text",
            flex: 2,
        },
        {
            field: "id",
            flex: 2,
        },
        {
            field: "categories",
            flex: 2,
        },
        {
            field: "categoryNames",
            flex: 2,
        },
    ]

    // All Affirmations
    // const [affirmations, setAffirmations] = useState<Array<AffirmationWithCategory>>([]);
    const affirmations = useSelector((state: AppState) => state.affirmations);
    const categories = useSelector((state: AppState) => state.categories);


    // Update Dialog variables
    const [openUpdateDialog, setUpdateDialog] = useState(false);
    const [selectedAffirmation, setSelectedAffirmation] = useState<AffirmationWithCategory>();

    // Delete Dialog Variables
    const [openDeleteDialog, setDeleteDialog] = useState(false);


    // Table Data variables
    const [searchText, setSearchText] = useState('');
    const [rows, setRows] = useState<any>([]);

    // gets all affirmations and sets the table
    const getAllAffirmationsToTable = () => {

        // Set Tables Rows data
        setRows(affirmations.map(e => {
            const categoryNames: Array<string> = getCategoryNamesByIds(categories, e.categoryIds);
            return {
                id: e.id,
                text: e.text,
                categories: e.categoryIds.join(', '),
                categoryNames: categoryNames.join(', ')
            }
        }))
    }

    // Get affirmations
    useEffect(() => {
        getAllAffirmationsToTable();
        setSelectedAffirmation(undefined);
    }, [affirmations])


    // Search Text
    useEffect(() => {
        requestSearch(searchText);
    }, [affirmations])

    // Handles Search 
    const requestSearch = (searchValue: string) => {
        setSearchText(searchValue);
        const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
        const rowData = affirmations.map(e => {
            const categoryNames: Array<string> = getCategoryNamesByIds(categories, e.categoryIds);
            return {
                id: e.id,
                text: e.text,
                categories: e.categoryIds.join(', '),
                categoryNames: categoryNames.join(', ')
            }
        });
        const filteredRows = rowData.filter((row: any) => {
            return Object.keys(row).some((field: any) => {
                return searchRegex.test(row[field].toString());
            });
        });
        setRows(filteredRows);
    };


    // Handle Update Button Click
    const handleUpdate = () => {
        setUpdateDialog(true);
    }
    // Handle Delete Button Click
    const handleDelete = () => {
        setDeleteDialog(true);
    }

    return (
        <>
            <Paper style={{ padding: 10 }}>
                <h2> Affirmations </h2>

                <div style={{ height: 500 }}>


                    {
                        selectedAffirmation ?
                            <Box margin={2}>
                                <Button style={{ margin: 10 }} variant="outlined" onClick={handleUpdate}>
                                    Update
                                </Button>
                                <Button variant="outlined" onClick={handleDelete}>
                                    Delete
                                </Button>
                            </Box>
                            :
                            <Box />
                    }


                            <DataGrid
                                components={{ Toolbar: QuickSearchToolbar }}
                                // style={{ display: 'flex', width: '100%' }}
                                onCellClick={(val) => {
                                    const affirmationId = val.id.toString();
                                    const _affirmation = affirmations.find(e => e.id === affirmationId);
                                    setSelectedAffirmation(_affirmation);
                                }}
                                rows={rows}
                                columns={columns}
                                componentsProps={{
                                    toolbar: {
                                        value: searchText,
                                        onChange: (event: any) => requestSearch(event.target.value),
                                        clearSearch: () => requestSearch(''),
                                    },
                                }}
                            />
                </div>

            </Paper>

            {
                selectedAffirmation ?
                    <>
                        <DeleteAffirmationDialog
                            open={openDeleteDialog}
                            affirmation={selectedAffirmation}
                            handleClose={() => setDeleteDialog(false)}
                        />
                        <UpdateAffirmationDialog
                            open={openUpdateDialog}
                            affirmation={selectedAffirmation}
                            handleClose={() => setUpdateDialog(false)} />
                    </>
                    : <></>
            }
        </>
    );
}


export default AllAffirmationsComponent;